module.exports = __webpack_public_path__ + "assets/img/2868d7c9673fa8eab72866b041e8ecfa.svg";